.time-inputs {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.time-input {
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border 0.2s linear, box-shadow 0.2s linear;
  border-radius: 4px;
  color: #555;
  display: inline-block;
  font-size: 14px;
  height: 20px;
  line-height: 20px;
  margin-bottom: 10px;
  padding: 4px 6px;
  vertical-align: middle;
  margin-bottom: 0px;
  width: 70px;
}

.time-input[readonly] {
  background-color: #eee;
  cursor: not-allowed;
}

.time-input:focus {
  border-color: rgb(92, 165, 224);
  border-style: solid;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 2px rgba(0, 115, 207, 0.5);
  outline: none;
  text-decoration: none;
}

.time-dropdown {
  position: fixed;
  width: 160px;
  max-height: 200px;
  overflow-y: auto;
  background-color: #fff;
  border-radius: 6px;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  display: none;
  pointer-events: auto; /* Ensure mouse events work */
  outline: none; /* Remove focus outline */
  -webkit-user-select: none; /* Prevent text selection */
  user-select: none;
}

.time-option {
  padding: 6px 12px;
  cursor: pointer;
  transition: background-color 0.2s;
  -webkit-user-select: none; /* Prevent text selection */
  user-select: none;
  outline: none;
}

.time-option:hover {
  background-color: var(--theme-menu-hover-background);
}

.time-option.selected {
  background-color: var(--theme-menu-active-background);
}
